<template>
<div>

	<!-- page-heading -->
	<page-heading :show="true" pageTitle="ECOC-HEADER"></page-heading>


	<div class="columns">

		<div class="col-main">

			<!-- show loading indicator -->
			<loading-indicator :loading="isLoading"></loading-indicator>

			<template v-if="!isLoading">

				<div class="box box--saveable">

					<!-- visibility save overlay -->
					<div v-if="isVisibilityLoading" class="visibility-overlay">
						<span class="fa fa-spinner fa-spin"></span>
					</div>

					<sortable-tree
						:data="treeData"
						childrenAttr="children"
						mixinParentKey="$parent"
						closeStateKey="foldClose"
						:dragEnable="true"
						@changePosition="changePosition">

						<template slot-scope="{item}">

							<div class="custom-tree-content" :class="[{'invisible': item.level > -1 && item.children && item.children.length > 0 && !item.visible}, {'exitChild': item.children && item.children.length}]">
						
								<span v-if="item.children && item.children.length" @click="changeState(item)" :class="['icon toggle is-small', {'is-disabled': item.level == -1}]">
									<i :class="['fa', item['foldClose'] ? 'fa-plus-square-o' : 'fa-minus-square-o']" aria-hidden="true"></i>
								</span>

								<template v-if="item.children && item.children.length && item.level > -1">

									<div class="imgWrapper">
										<span class="lazy-img-fadein" v-lazy:background-image="getImage(item.asset)"></span>
									</div>

									<span class="name has-cursor-pointer" @click="changeState(item)">{{item.name}} ({{ item.children.length }})</span>

								</template>

								<template v-else>
									<span class="name">{{item.name}}</span>
								</template>


								<template v-if="item.level >= -1">

									<template v-if="item.level >= 1">
						
										<span v-if="item.children.length > 0 || (item.products && item.products.length > 0)"
											class="icon is-small has-cursor-pointer is-disabled-soft"
											title="Kategorie löschen (Löschen derzeit nicht möglich, da Produkte in der Kategorie enthalten sind)">
											<i class="fa fa-trash"></i>
										</span>

										<pop-confirm v-else
											class="icon is-small has-cursor-pointer"
											content="Soll diese Kategorie wirklich gelöscht werden?"
											icon="question-circle-o"
											cancel-text="abbrechen"
											ok-text="ja, löschen"
											:on-ok="function() { deleteCategory(item) }">
											<i class="fa fa-trash" title="Kategorie löschen"></i>
										</pop-confirm>

									</template>

									<span v-if="item.level > -1" class="icon is-small has-cursor-pointer" title="Sichtbarkeit ändern" @click="categoryVisibility(item)">
										<i :class="'fa ' + (item.visible ? 'fa-eye' : 'fa-eye-slash')"></i>
									</span>

									<span v-if="item.level > -1" class="icon is-small has-cursor-pointer" title="Name ändern" @click="categoryEdit(item)">
										<i class="fa fa-pencil"></i>
									</span>

									<span :class="['icon is-small has-cursor-pointer', { 'is-disabled': item.level > 1 }]" title="Kategorie hinzufügen" @click="categoryAdd(item)">
										<i class="fa fa-plus"></i>
									</span>

								</template>

							</div>
						</template>

					</sortable-tree>

				</div>


				<modal
					:title="modalTitle"
					transition="fadeDown"
					cancel-text="Abbrechen"
					:show-ok="false"
					:backdrop-closable="false"
					:is-show="showModal"
					@close="closeModalFunc"
					class="onlineCategoryModal vcenter">

						<!-- NEW CATEGORY -->
						<template v-if="modalType == 'newCategory'">

							<form-input inputType="text" :showLabel="false" placeholder="Kategoriename" inputSize="is-medium" v-model="newCategory.name" :isHorizontal="false"></form-input>
							<div slot="footer">
								<span class="button" @click="categoryAddCancel">Abbrechen</span>
								<span :class="['button is-success', { 'is-loading': isSaving }]" @click="categoryAddSubmit">speichern</span>
							</div>

						</template>

						<!-- EDIT CATEGORY -->
						<template v-else-if="modalType == 'editCategory'">

							<form-input inputType="text" :showLabel="false" placeholder="Kategoriename" inputSize="is-medium" v-model="activeItem.name" :isHorizontal="false"></form-input>

							<div class="control" v-if="activeItem.level < 3">
								<vue-dropzone
									ref="dzOnlineCategory"
									id="dzOnlineCategory"
									url= "fileProcessing/upload?preset=equipmentOnlineCategory"
									:maxFiles="1"
									:thumbnailWidth="100"
									:thumbnailHeight="100"
									acceptedFiles= ".jpg,.jpeg,.png,.gif"
									dictDefaultMessage="<i class='fa fa-cloud-upload'></i>Bild hochladen"
									v-on:vdropzone-removed-file="dzDeleteImage"
									v-on:vdropzone-mounted="dzInit"
									v-on:vdropzone-success="dzSuccess"
									:key="activeItem.id" class="dzSingle">
								</vue-dropzone>
							</div>

							<div slot="footer">
								<span class="button" @click="categoryEditCancel">Abbrechen</span>
								<span :class="['button is-success', { 'is-loading': isSaving }]" @click="categoryEditSubmit">speichern</span>
							</div>

						</template>

				</modal>

			</template>

		</div>

    </div>

</div>

</template>




<script>
import SortableTree from 'vue-sortable-tree'
import vue2Dropzone from '../utils/dropzoneWrapper'

export default {

	components: {
		[SortableTree.name]: SortableTree,
		vueDropzone: vue2Dropzone,
	},

	data() {

		var self = this;

		return {
			showTree: false,

			isLoading: false,
			isSaving: false,
			isVisibilityLoading: false,
			showModal: false,
			modalType: null,

			activeItem: {},
			saveItemName: {},
			newCategory: null,
			newCategoryParent: null,
			closeModalFunc: null,

			treeData: {
				name: 'Online Kategorien',
				level: '-1',
				foldClose: false,
				children: []
			}

		}

	},

    created() {

        this.fetchData();

    },

    mounted() {


    },

    methods: {


		getImage(asset) {

			if(asset == null) {
				return ""
			}

			return this.$config.assets + asset['path'] + '/' + asset['filename'];

		},

		dzInit() {

			if(this.activeItem.asset && this.activeItem.asset.filename != null) {

				var url = this.$config.assets + this.activeItem.asset.path + '/' + this.activeItem.asset.filename;
				var mockFile = { id: 'onlineCategoryImage', name: this.activeItem.asset.filename, type: "image/*", size: 123 }

				// add mockFile to our dropzone
				this.$refs.dzOnlineCategory.$children[0].manuallyAddFile(mockFile, url);

			}

		},

		dzSuccess(file) {

			var result = JSON.parse(file.xhr.response);
			var self = this;

			this.activeItem.asset = {
				filename: result.fileName,
				path: result.dir,
				uploadFilename: file.name
			}

			// save
			setTimeout(function() {
				 self.save();
			}, 250)

		},

		dzDeleteImage(file, error, xhr) {

			// this.removeFileRecursive(this.treeData.children);
			this.activeItem.asset = null;
			var self = this;

			// save
			setTimeout(function() {
				 self.save();
			}, 250)

		},

		categoryImageAddCancel() {

			this.showModal = false;
			this.activeItem = "";
			this.modalType = null;

		},

    changeState(item) {
			this.$set(item, 'foldClose', !item['foldClose'])
    },

	  changePosition(option) {

			// if the category was moved to another level ...
			if(option.afterParent.id != option.beforeParent.id) {

				// reinsert in old position
				option.beforeParent.children.splice(option.beforeIndex, 0, option.data);

				// delete from new position
				var x = option.afterParent.children.findIndex(function(node) {
					return node.id == option.data.id;
				});
				option.afterParent.children.splice(x, 1);

				this.$notify.open( { content: 'Das Verschieben von Kategorien ist nur innerhalb derselben Ebene erlaubt!', placement: 'center', type: 'warning', duration: 6000});

				return false;

			// otherwise just take care of the sortorder
			} else {

				this.changeSortorder(option.afterParent.children);
				this.changeSortorder(option.beforeParent.children);

				this.save();

			}

	  },

		categoryAdd(item) {

			// security check: only allow new categories for levels -1 to 1
			if(item.level > 1) {
				return false;
			}

			let newCategory = {
				name: 'Neue Kategorie',
				level: item.level + 1,
				parent: item.id,
				foldClose: true,
				children: [],
			}

			this.newCategoryParent = item;
			this.modalType = 'newCategory';
			this.newCategory = newCategory;
			this.modalTitle = "Kategorie hinzufügen";
			this.closeModalFunc = this.categoryAddCancel;
			this.showModal = true;

		},

		categoryAddSubmit() {

			this.isSaving = true;

			// open the (parent) category
			this.newCategoryParent.foldClose = false;

			// add the new category to the children of its parent
			this.newCategoryParent.children.push(this.newCategory);

			// resort
			this.changeSortorder(this.newCategoryParent.children);

			// console.log("this.newCategoryParent: ", this.newCategoryParent);

			this.save(true, false)
				.then((res) => {

					this.axios
						.get(this.$config.api + 'equipmentOnlineCategory?include=equipmentOnlineCategory.children,equipmentOnlineCategory.asset,equipmentOnlineCategory.products&filters[parent]=NULL')
		        .then((response) => {

							// recursively add "foldClose" property to all elements and set it to true
							this.treeData.children = this.recursiveAddFoldCloseProperty(response.data.equipmentOnlineCategory, this.newCategoryParent);

							this.newCategoryParent = null;
							this.isSaving = false;
							this.showModal = false;

						});

				})

		},

		categoryVisibility(item) {

			item.visible = !item.visible;

			if(item.children && item.children.length > 0) {
				item.children.forEach(node => {
					node.visible = item.visible;
					if(node.children && node.children.length > 0) {
						this.recursiveAddFoldCloseProperty(node.children);
					}
				})
			}

			this.isVisibilityLoading = true;
			this.save()
				.then(() => {
					this.isVisibilityLoading = false;
				})
				.catch(() => {
					this.isVisibilityLoading = false;
				});

		},

		categoryAddCancel() {

			this.showModal = false;
			this.modalType = null;
		},

		categoryEdit(item) {

			this.activeItem = item;
			this.modalType = 'editCategory';
			this.saveItemName = item.name;
			this.modalTitle = "Kategorie bearbeiten";
			this.closeModalFunc = this.categoryEditCancel;
			this.showModal  = true;

		},

		categoryEditSubmit() {

			this.showModal = false;
			this.save();

		},

		categoryEditCancel() {

			this.activeItem.name = this.saveItemName;
			this.showModal = false;
			this.modalType = null;

		},

		categoryDelete(item) {

			item.$parent.children.forEach(function(child, index) {

				if(child.id == item.id) {
					item.$parent.children.splice(index, 1);
				}

				child.sortorder = index;

			})

			this.save();

		},

		deleteCategory(item) {

			const parent = item.$parent;
			if (!parent || !parent.children) return;

			this.isVisibilityLoading = true;

			// remove from parent children
			parent.children.forEach((child, index) => {
				if (child.id == item.id) {
					parent.children.splice(index, 1);
				}
			});

			// resort
			this.changeSortorder(parent.children);

			// save and refresh
			this.save(false, true)
				.then((res) => {
					this.axios
						.get(this.$config.api + 'equipmentOnlineCategory?include=equipmentOnlineCategory.children,equipmentOnlineCategory.asset,equipmentOnlineCategory.products&filters[parent]=NULL')
						.then((response) => {
							this.treeData.children = this.recursiveAddFoldCloseProperty(response.data.equipmentOnlineCategory, parent);
							this.$notify.success({ content: 'Kategorie erfolgreich gelöscht' });
							this.isVisibilityLoading = false;
						});
				})
				.catch((err) => {
					this.isVisibilityLoading = false;
				});

		},

		changeSortorder(nodes) {

			nodes.forEach(function(node, index) {
				node.sortorder = index;
			});

		},


		save(isNewCategory = false, isSilent = false) {

			var self = this;

			return new Promise(function(resolve, reject) {

				// sanitize Array
				const getCircularReplacer = () => {

					const seen = new WeakSet;

					return (key, value) => {

						if (typeof value === "object" && value !== null) {
							if (seen.has(value)) {
								return;
							}
							seen.add(value);
						}

						return value;

					};

				};

				let saveData = JSON.parse(JSON.stringify(self.treeData.children, getCircularReplacer()));

				// call save method
				self.entityCreateOrUpdate('equipmentOnlineCategory', saveData, { isSilent: isSilent, msg: 'ECOC-MSG-SUCCESSFULLY_SAVED' })
					.then((response) => {
						resolve(response);
					}).catch((error) => {
           	this.isLoading = false;
						console.log("error: ", error);
					});

			})

		},

    fetchData() {

		this.isLoading = true;

		// make the request
		this.axios
			.get(this.$config.api + 'equipmentOnlineCategory?include=equipmentOnlineCategory.children,equipmentOnlineCategory.asset,equipmentOnlineCategory.products&filters[parent]=NULL')
			.then((response) => {

						// recursively add "foldClose" property to all elements and set it to true
						this.treeData.children = this.recursiveAddFoldCloseProperty(response.data.equipmentOnlineCategory);
						this.isLoading = false;

			}).catch((error) => {
	          this.isLoading = false;
						console.log(error);
				});
		},

		recursiveAddFoldCloseProperty(nodes, exclude=false, level=0) {

			//console.log("exclude: ", exclude.$parent);

			nodes.forEach((node) => {

				node.level = level;

				if(exclude && (node.name == exclude.name || exclude.$parent && exclude.$parent.name == node.name)) {
					node.foldClose = false;
				} else {
					node.foldClose = true;
				}

				if(node.children && node.children.length > 0) {
					this.recursiveAddFoldCloseProperty(node.children, exclude, level + 1);
				}

			})

			return nodes;

		}

  }

}
</script>


<style lang="scss">

	@import '~../../assets/css/variables.scss';

	.sortable-tree .content {
		margin: 0;
	}
	.custom-tree-content {

		position: relative;
		top: 2px;
		z-index: 1;

		font-size: 14px;

	    top: 0;
	    z-index: 1;
	    display: flex;
	    align-items: center;


		&.exitChild {
			margin-left: -7px;
			display: flex;
		  align-items: center;
		}

		&.invisible {
			opacity: .3;
			color: $themeColor1;
		}

	}
	.custom-tree-content .titleLine {
		margin-left: 5px;
	}
	.custom-tree-content .toggle.icon {
		/* background-color: #e8ecf0;*/
		background-color: #fff;
		cursor: pointer;
	}
	.custom-tree-content .name {
		margin: 0 8px 0 5px;
		transition: color .3s ease;
	}

</style>

<style>

	.custom-tree-content .icon.is-small.has-cursor-pointer {
		font-size: 12px;
		height: 18px;
		width: 18px;
		line-height: 18px;
		padding: 0;
		background-color: #eee;
		border-radius: 3px;
		margin-right: 2px;
		transition: all .3s ease;
	}
	.custom-tree-content .icon.is-active {
		background-color: lightgreen !important;
	}
	.custom-tree-content .icon:not(.toggle).is-disabled {
		display: none;
	}
	.custom-tree-content .icon:not(.toggle):hover {
		background-color: #888;
		color: #fff;
	}
	.custom-tree-content .icon.is-disabled-soft {
		opacity: 0.5;
		cursor: not-allowed;
	}
	.custom-tree-content span.name:hover {
		color: #aaa;
	}
	.onlineCategoryModal .control:not(:last-child) {
		max-width: 100%;
		margin: 0 0 15px 0 0;
	}
	.onlineCategoryModal .control:last-child {
		max-width: 100%;
		margin: 0;
	}

</style>

<style scoped>
	.imgWrapper {
		width: 24px;
		height: 24px;
	}
	.imgWrapper > span {
		display: block;
		width: 100%;
		height: 100%;
		background-size: cover;
		background-position: 50% 50%;
		background-size: 100% !important;
	}
	.imgWrapper > span[lazy=error] {
		filter: opacity(50%);
	}

	.box--saveable {
		position: relative;
	}
	.visibility-overlay {
		position: absolute;
		inset: 0;
		background: rgba(255, 255, 255, 0.65);
		z-index: 10;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 24px;
		color: #888;
		border-radius: inherit;
	}

	::v-deep .modal-card-body {
		overflow: hidden;
	}
	::v-deep .customdropzone.dzSingle {
		/*width: 200px !important;*/
		height: 130px !important;
		margin: 0 auto;
	}
	::v-deep .customdropzone.dzSingle .dz-preview {
		margin: 0 auto !important;
	}
</style>
